import { useMutation } from '@tanstack/react-query';

import { parseApiError, overrideOrganizationHeader } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useDeleteChildOrganizationMutation = () => {
  const { enterpriseOrgId } = useOrganizations();

  return useMutation({
    mutationFn: (organizationId: string) => {
      return apiClient.enterprises.deleteChildOrganization(
        {
          enterpriseId: enterpriseOrgId!,
          id: organizationId,
        },
        {
          headers: overrideOrganizationHeader(enterpriseOrgId),
        }
      );
    },
    onError: (error: unknown) => {
      const parsedError = parseApiError(error);
      notify.error(parsedError);
    },
  });
};
